import { ApplicationNotification, ApplicationNotificationSpecificationBase } from './_abstract_impl';

export type Variants = 'danger' | 'warning' | 'success' | 'info';

export interface ToastNotificationSpecification extends ApplicationNotificationSpecificationBase<ToastNotification> {
	label: string;
	message?: string;
	variant?: Variants;
	duration?: number;
}

export class ToastNotification extends ApplicationNotification {
	public readonly event = 'toast';
	public readonly type = 'toast';
	public readonly label: string;
	public readonly message: string | null;
	public readonly variant: Variants;
	public readonly duration: number;

	constructor(spec: ToastNotificationSpecification) {
		super();

		this.label = spec.label;
		this.message = spec.message ?? null;
		this.variant = spec.variant ?? 'success';
		this.duration = spec.duration ?? 5000;
	}
}
